import { render, staticRenderFns } from "./DialogInformation.vue?vue&type=template&id=0806eeb7&"
import script from "./DialogInformation.vue?vue&type=script&lang=js&"
export * from "./DialogInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports